import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetGuestRidesCountsQueryVariables = Types.Exact<{
  scope: Types.Guestrides_Bool_Exp;
  window: Types.Guestrides_Bool_Exp;
}>;


export type GetGuestRidesCountsQuery = { __typename?: 'query_root', upcoming: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, active: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, completed: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, cancelled: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null }, deleted: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null } };


export const GetGuestRidesCountsDocument = gql`
    query getGuestRidesCounts($scope: guestrides_bool_exp!, $window: guestrides_bool_exp!) {
  upcoming: guestrides_aggregate(
    where: {_and: [$scope, $window, {status: {_in: ["new", "failed"]}}]}
  ) {
    aggregate {
      count
    }
  }
  active: guestrides_aggregate(
    where: {_and: [$scope, $window, {status: {_in: ["pending", "booked", "driver_enroute", "driver_arrived", "riding"]}}]}
  ) {
    aggregate {
      count
    }
  }
  completed: guestrides_aggregate(
    where: {_and: [$scope, $window, {status: {_in: ["completed"]}}]}
  ) {
    aggregate {
      count
    }
  }
  cancelled: guestrides_aggregate(
    where: {_and: [$scope, $window, {status: {_in: ["cancelled"]}}]}
  ) {
    aggregate {
      count
    }
  }
  deleted: guestrides_aggregate(
    where: {_and: [$scope, $window, {status: {_in: ["deleted"]}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetGuestRidesCountsQuery__
 *
 * To run a query within a React component, call `useGetGuestRidesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestRidesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestRidesCountsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      window: // value for 'window'
 *   },
 * });
 */
export function useGetGuestRidesCountsQuery(baseOptions: Apollo.QueryHookOptions<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables> & ({ variables: GetGuestRidesCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>(GetGuestRidesCountsDocument, options);
      }
export function useGetGuestRidesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>(GetGuestRidesCountsDocument, options);
        }
// @ts-ignore
export function useGetGuestRidesCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>;
export function useGetGuestRidesCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRidesCountsQuery | undefined, GetGuestRidesCountsQueryVariables>;
export function useGetGuestRidesCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>(GetGuestRidesCountsDocument, options);
        }
export type GetGuestRidesCountsQueryHookResult = ReturnType<typeof useGetGuestRidesCountsQuery>;
export type GetGuestRidesCountsLazyQueryHookResult = ReturnType<typeof useGetGuestRidesCountsLazyQuery>;
export type GetGuestRidesCountsSuspenseQueryHookResult = ReturnType<typeof useGetGuestRidesCountsSuspenseQuery>;
export type GetGuestRidesCountsQueryResult = Apollo.QueryResult<GetGuestRidesCountsQuery, GetGuestRidesCountsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (upcoming, active, completed, cancelled, deleted): returns the full response object.
 * @source {@link src/features/guestRides/counts/getGuestRidesCounts.query.gql}
 */
export async function getGuestRidesCounts(
  variables: GetGuestRidesCountsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetGuestRidesCountsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetGuestRidesCountsQuery>(
    GetGuestRidesCountsDocument,
    variables,
    requestOptions
  )
}